import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {CandidatesApplied, Mission} from '../../../../../../models/Mission';
import {candidatAccepted, candidateApplied} from '../../../../../../shared/utils/data/shared.data';
import {CandidatStatusOnMission, MissionStatusEnum,} from '../../../../../../shared/utils/enums';
import {isMissionExpired} from '../../../../../../shared/utils/utils.functions';
import {SvgIconComponent} from "angular-svg-icon";
import {SharedModule} from "../../../../../../shared/shared.module";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {MissionCandidaturesComponent} from "../../mission-candidatures/mission-candidatures.component";

@Component({
  selector: 'app-table-en-cour-action',
  templateUrl: './table-en-cour-action.component.html',
  styleUrl: './table-en-cour-action.component.scss',
  imports: [
    SvgIconComponent,
    SharedModule,
    TooltipModule,
    MissionCandidaturesComponent
  ],
  standalone: true
})
export class TableEnCourActionComponent implements OnInit {
  @Input()
  set data(mission : Mission) {
    this._data = mission;
    this.expired = isMissionExpired(this._data.enddate, this._data.endtime);
    this.candidatList = this._data.candidatesApplied;
    if (candidatAccepted.includes(this._data.statusOfCandidatOnMission) || candidateApplied.includes(this._data.statusOfCandidatOnMission)) {
          this.statusCandidateAccepted = this._data.statusOfCandidatOnMission
    }
    // this.indexAcceptedCandidate = this.candidatList?.findIndex((c) =>
    //   candidatAccepted.includes(this._data.statusOfCandidatOnMission) || candidateApplied.includes(this._data.statusOfCandidatOnMission)
    // );
    // if (this.indexAcceptedCandidate > -1) {
    //   this.statusCandidateAccepted = this._data.statusOfCandidatOnMission;
    // }
  };

  @Input() column: any


  _data: Mission;
  candidatList: CandidatesApplied[] = [];
  candidatAccepted: CandidatesApplied[] = [];
  indexAcceptedCandidate: number;

  statusCandidateAccepted: CandidatStatusOnMission;
  expired = false;
  loadingContract = false;


  constructor(
  ) {}

  ngOnInit(): void {

  }

  get totallyValidated() {
    if (['VALIDATED', 'INVALIDATED'].includes(this._data.missionStatus)) {
      return this._data?.missionStatus == 'VALIDATED' ? 'Validée' : 'Non validée';
    }
    return false;
  }

  // A canceled offer/candidacy must read "Offre de mission annulée" instead of falling
  // through to the default "En cours" (candidate-scope rows carry no missionStatus).
  get isCanceledOffer(): boolean {
    const s = this._data?.statusOfCandidatOnMission;
    return this._data?.missionStatus === MissionStatusEnum.CANCELED
      || s === CandidatStatusOnMission.CANCELED_BY_CANDIDATE
      || s === CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY
      || s === CandidatStatusOnMission.CANCELLATION_ACCEPTED_AFTER_SIGNING;
  }

  protected readonly CandidatStatusOnMission = CandidatStatusOnMission;
  protected readonly MissionStatusEnum = MissionStatusEnum;

  isTotallyAffected() {
    return this._data?.candidatesApplied.some(item => item.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH);
  }

  isAccepted() {
    return this._data?.candidatesApplied.some(item => item.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED);
  }

  isContractWaitingToBevalidated() {
    return this._data?.candidatesApplied.some(item => item.statusOfCandidatOnMission === CandidatStatusOnMission.CONTRACT_PENDING_VALIDATION);
  }

}
